// Auto-generated by generate_stats.py
// Locations mentioned in documents

export const locationData = [
  {
    "location": "New York",
    "count": 1845
  },
  {
    "location": "United States",
    "count": 1385
  },
  {
    "location": "Israel",
    "count": 967
  },
  {
    "location": "Palm Beach",
    "count": 923
  },
  {
    "location": "China",
    "count": 882
  },
  {
    "location": "Florida",
    "count": 709
  },
  {
    "location": "Europe",
    "count": 585
  },
  {
    "location": "Washington",
    "count": 573
  },
  {
    "location": "London",
    "count": 510
  },
  {
    "location": "US",
    "count": 501
  },
  {
    "location": "Russia",
    "count": 471
  },
  {
    "location": "Iran",
    "count": 399
  },
  {
    "location": "Syria",
    "count": 396
  },
  {
    "location": "Saudi Arabia",
    "count": 384
  },
  {
    "location": "Germany",
    "count": 379
  },
  {
    "location": "Egypt",
    "count": 372
  },
  {
    "location": "USA",
    "count": 370
  },
  {
    "location": "Paris",
    "count": 368
  },
  {
    "location": "Hong Kong",
    "count": 357
  },
  {
    "location": "Japan",
    "count": 345
  },
  {
    "location": "France",
    "count": 338
  },
  {
    "location": "Miami",
    "count": 335
  },
  {
    "location": "West Palm Beach",
    "count": 314
  },
  {
    "location": "U.S.",
    "count": 307
  },
  {
    "location": "White House",
    "count": 296
  },
  {
    "location": "California",
    "count": 292
  },
  {
    "location": "West Bank",
    "count": 285
  },
  {
    "location": "Australia",
    "count": 281
  },
  {
    "location": "Moscow",
    "count": 271
  },
  {
    "location": "India",
    "count": 262
  },
  {
    "location": "NY",
    "count": 254
  },
  {
    "location": "UK",
    "count": 253
  },
  {
    "location": "Iraq",
    "count": 250
  },
  {
    "location": "New York City",
    "count": 247
  },
  {
    "location": "Middle East",
    "count": 238
  },
  {
    "location": "Canada",
    "count": 233
  },
  {
    "location": "Jerusalem",
    "count": 220
  },
  {
    "location": "Lebanon",
    "count": 218
  },
  {
    "location": "Gaza",
    "count": 214
  },
  {
    "location": "Los Angeles",
    "count": 211
  },
  {
    "location": "America",
    "count": 206
  },
  {
    "location": "Italy",
    "count": 204
  },
  {
    "location": "Turkey",
    "count": 202
  },
  {
    "location": "United Kingdom",
    "count": 192
  },
  {
    "location": "Tel Aviv",
    "count": 192
  },
  {
    "location": "Brazil",
    "count": 185
  },
  {
    "location": "Manhattan",
    "count": 184
  },
  {
    "location": "Arizona State University",
    "count": 183
  },
  {
    "location": "Spain",
    "count": 172
  },
  {
    "location": "Mexico",
    "count": 169
  },
  {
    "location": "Harvard",
    "count": 167
  },
  {
    "location": "Chicago",
    "count": 161
  },
  {
    "location": "New York Times",
    "count": 161
  },
  {
    "location": "San Francisco",
    "count": 161
  },
  {
    "location": "Beijing",
    "count": 161
  },
  {
    "location": "England",
    "count": 157
  },
  {
    "location": "Cambridge",
    "count": 152
  },
  {
    "location": "FL",
    "count": 151
  },
  {
    "location": "Libya",
    "count": 150
  },
  {
    "location": "Boston",
    "count": 144
  },
  {
    "location": "New Mexico",
    "count": 139
  },
  {
    "location": "DC",
    "count": 138
  },
  {
    "location": "Jordan",
    "count": 138
  },
  {
    "location": "Palm Beach County",
    "count": 134
  },
  {
    "location": "Palestine",
    "count": 128
  },
  {
    "location": "Africa",
    "count": 127
  },
  {
    "location": "Utah",
    "count": 127
  },
  {
    "location": "South Africa",
    "count": 126
  },
  {
    "location": "Singapore",
    "count": 126
  },
  {
    "location": "Dubai",
    "count": 126
  },
  {
    "location": "Switzerland",
    "count": 123
  },
  {
    "location": "Asia",
    "count": 122
  },
  {
    "location": "Harvard University",
    "count": 120
  },
  {
    "location": "Texas",
    "count": 115
  },
  {
    "location": "Qatar",
    "count": 114
  },
  {
    "location": "Sinai",
    "count": 114
  },
  {
    "location": "Virgin Islands",
    "count": 112
  },
  {
    "location": "Afghanistan",
    "count": 112
  },
  {
    "location": "Southern District",
    "count": 111
  },
  {
    "location": "Greece",
    "count": 109
  },
  {
    "location": "NYC",
    "count": 107
  },
  {
    "location": "St. Thomas",
    "count": 104
  },
  {
    "location": "Taiwan",
    "count": 103
  },
  {
    "location": "Berlin",
    "count": 98
  },
  {
    "location": "Hawaii",
    "count": 97
  },
  {
    "location": "Kuwait",
    "count": 95
  },
  {
    "location": "Cairo",
    "count": 95
  },
  {
    "location": "Indonesia",
    "count": 94
  },
  {
    "location": "North Korea",
    "count": 94
  },
  {
    "location": "Mar-a-Lago",
    "count": 93
  },
  {
    "location": "MA",
    "count": 92
  },
  {
    "location": "CA",
    "count": 92
  },
  {
    "location": "MIT",
    "count": 91
  },
  {
    "location": "Britain",
    "count": 88
  },
  {
    "location": "Arizona",
    "count": 88
  },
  {
    "location": "New Jersey",
    "count": 87
  },
  {
    "location": "Ukraine",
    "count": 87
  },
  {
    "location": "Pakistan",
    "count": 87
  },
  {
    "location": "NSA",
    "count": 87
  },
  {
    "location": "Brooklyn",
    "count": 84
  }
];
